import React from 'react';

export default function AssingTeammate() {
  return (
    <svg
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.5"
        cx="44.4999"
        cy="43.9999"
        r="39.6977"
        fill="white"
      />
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.8865 26.144L70.7238 22.3479L66.8856 26.0721L62.7007 22.3485L58.9641 26.0728L54.6777 22.3494L51.0428 26.0739L44.429 20.462L46.3699 18.1745L50.8501 21.976L54.5079 18.2281L58.8237 21.9771L62.584 18.2291L66.7972 21.9778L70.6601 18.2296L76.908 23.9274L74.8865 26.144Z"
        fill="#DDDBF9"
      />
      <path
        opacity="0.21"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.4715 62.3376L64.0708 75.1442L63.1169 76.9021L39.5176 64.0954L33.7666 79.7558C33.1873 81.3332 31.0388 81.5363 30.1742 80.0953L3.96522 36.4137L5.6802 35.3847L31.8892 79.0663L37.6402 63.406C38.0607 62.2609 39.3994 61.7558 40.4715 62.3376Z"
        fill="#B5B3C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.5 7.5C24.3416 7.5 8 23.8416 8 44C8 64.1584 24.3416 80.5 44.5 80.5C64.6584 80.5 81 64.1584 81 44C81 23.8416 64.6584 7.5 44.5 7.5ZM5 44C5 22.1848 22.6848 4.5 44.5 4.5C66.3152 4.5 84 22.1848 84 44C84 65.8152 66.3152 83.5 44.5 83.5C22.6848 83.5 5 65.8152 5 44Z"
        fill="#A7A5BA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.5 44C88.5 68.3005 68.8005 88 44.5 88C20.1995 88 0.5 68.3005 0.5 44C0.5 19.6995 20.1995 0 44.5 0C68.8005 0 88.5 19.6995 88.5 44ZM44.5 82C65.4868 82 82.5 64.9868 82.5 44C82.5 23.0132 65.4868 6 44.5 6C23.5132 6 6.5 23.0132 6.5 44C6.5 64.9868 23.5132 82 44.5 82Z"
        fill="#E0DFE6"
      />
      <g opacity="0.3">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.4554 51.4653C25.7316 51.4653 25.9554 51.6892 25.9554 51.9653L25.9554 55.9611C25.9554 56.2373 25.7316 56.4611 25.4554 56.4611C25.1793 56.4611 24.9554 56.2373 24.9554 55.9611L24.9554 51.9653C24.9554 51.6892 25.1793 51.4653 25.4554 51.4653Z"
          fill="#B5B3C5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9533 53.9632C27.9533 54.2393 27.7295 54.4632 27.4533 54.4632L23.4575 54.4631C23.1814 54.4631 22.9575 54.2393 22.9575 53.9631C22.9575 53.687 23.1814 53.4631 23.4575 53.4631L27.4533 53.4632C27.7295 53.4632 27.9533 53.687 27.9533 53.9632Z"
          fill="#B5B3C5"
        />
      </g>
      <path
        opacity="0.6"
        d="M28 25.3994L29.1242 28.8177L32.5425 29.9419L29.1242 31.0661L28 34.4844L26.8758 31.0661L23.4575 29.9419L26.8758 28.8177L28 25.3994Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.34"
        d="M65.0959 61.8669L65.7196 63.7636L67.6163 64.3874L65.7196 65.0112L65.0959 66.9079L64.4721 65.0112L62.5754 64.3874L64.4721 63.7636L65.0959 61.8669Z"
        fill="#B5B3C5"
      />
      <path
        opacity="0.6"
        d="M61.9304 34.4844L62.7138 36.8665L65.0959 37.6499L62.7138 38.4333L61.9304 40.8154L61.1469 38.4333L58.7648 37.6499L61.1469 36.8665L61.9304 34.4844Z"
        fill="#BBB6F2"
      />
      <path
        d="M72.8995 40.0042C72.8995 40.6137 72.4053 41.1079 71.7957 41.1079C71.1861 41.1079 70.692 40.6137 70.692 40.0042C70.692 39.3946 71.1861 38.9004 71.7957 38.9004C72.4053 38.9004 72.8995 39.3946 72.8995 40.0042Z"
        fill="#D9D9D9"
      />
      <path
        d="M36.6882 75.3684C36.6882 75.978 36.1941 76.4722 35.5845 76.4722C34.9749 76.4722 34.4807 75.978 34.4807 75.3684C34.4807 74.7588 34.9749 74.2646 35.5845 74.2646C36.1941 74.2646 36.6882 74.7588 36.6882 75.3684Z"
        fill="#E0DFE6"
      />
      <mask
        id="mask0_1_1385"
        maskUnits="userSpaceOnUse"
        x="28"
        y="28"
        width="33"
        height="34"
      >
        <rect x="28" y="28.8669" width="33" height="33" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_1385)">
        <path
          d="M44.5 45.3669C42.9875 45.3669 41.6927 44.8284 40.6156 43.7513C39.5385 42.6742 39 41.3794 39 39.8669C39 38.3544 39.5385 37.0597 40.6156 35.9826C41.6927 34.9055 42.9875 34.3669 44.5 34.3669C46.0125 34.3669 47.3073 34.9055 48.3844 35.9826C49.4615 37.0597 50 38.3544 50 39.8669C50 41.3794 49.4615 42.6742 48.3844 43.7513C47.3073 44.8284 46.0125 45.3669 44.5 45.3669ZM33.5 56.3669V52.5169C33.5 51.7378 33.7008 51.0214 34.1023 50.3678C34.5028 49.7152 35.0354 49.2169 35.7 48.8732C37.1208 48.1628 38.5646 47.6297 40.0312 47.2741C41.4979 46.9193 42.9875 46.7419 44.5 46.7419C46.0125 46.7419 47.5021 46.9193 48.9688 47.2741C50.4354 47.6297 51.8792 48.1628 53.3 48.8732C53.9646 49.2169 54.4972 49.7152 54.8978 50.3678C55.2992 51.0214 55.5 51.7378 55.5 52.5169V56.3669H33.5ZM36.25 53.6169H52.75V52.5169C52.75 52.2649 52.6872 52.0357 52.5616 51.8294C52.4351 51.6232 52.2687 51.4628 52.0625 51.3482C50.825 50.7294 49.576 50.2652 48.3156 49.9553C47.0552 49.6464 45.7833 49.4919 44.5 49.4919C43.2167 49.4919 41.9448 49.6464 40.6844 49.9553C39.424 50.2652 38.175 50.7294 36.9375 51.3482C36.7313 51.4628 36.5653 51.6232 36.4397 51.8294C36.3133 52.0357 36.25 52.2649 36.25 52.5169V53.6169ZM44.5 42.6169C45.2563 42.6169 45.9039 42.3474 46.4429 41.8084C46.981 41.2704 47.25 40.6232 47.25 39.8669C47.25 39.1107 46.981 38.4635 46.4429 37.9254C45.9039 37.3864 45.2563 37.1169 44.5 37.1169C43.7437 37.1169 43.0966 37.3864 42.5585 37.9254C42.0195 38.4635 41.75 39.1107 41.75 39.8669C41.75 40.6232 42.0195 41.2704 42.5585 41.8084C43.0966 42.3474 43.7437 42.6169 44.5 42.6169Z"
          fill="#7F77D9"
        />
      </g>
    </svg>
  );
}
